import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SocialLogin = ({ onSocialLogin = () => {}, isLoading = false }) => {
  const socialProviders = [
    {
      id: 'google',
      name: 'Google',
      icon: 'Chrome',
      bgColor: 'bg-white',
      textColor: 'text-gray-700',
      borderColor: 'border-gray-300'
    },
    {
      id: 'apple',
      name: 'Apple',
      icon: 'Apple',
      bgColor: 'bg-black',
      textColor: 'text-white',
      borderColor: 'border-black'
    }
  ];

  const handleSocialLogin = (provider) => {
    // Mock social login
    alert(`${provider?.name} login would be handled here`);
    onSocialLogin(provider?.id);
  };

  return (
    <div className="w-full max-w-md space-y-4">
      {/* Divider */}
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border"></div>
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-4 bg-background text-text-secondary">Or continue with</span>
        </div>
      </div>
      {/* Social Login Buttons */}
      <div className="grid grid-cols-1 gap-3">
        {socialProviders?.map((provider) => (
          <Button
            key={provider?.id}
            variant="outline"
            size="lg"
            fullWidth
            onClick={() => handleSocialLogin(provider)}
            disabled={isLoading}
            className={`${provider?.bgColor} ${provider?.textColor} ${provider?.borderColor} hover:opacity-90`}
          >
            <div className="flex items-center justify-center space-x-3">
              <Icon name={provider?.icon} size={20} />
              <span>Continue with {provider?.name}</span>
            </div>
          </Button>
        ))}
      </div>
      {/* Alternative: Single row layout for desktop */}
      <div className="hidden md:grid md:grid-cols-2 md:gap-3 md:mt-4">
        {socialProviders?.map((provider) => (
          <Button
            key={`desktop-${provider?.id}`}
            variant="outline"
            size="default"
            onClick={() => handleSocialLogin(provider)}
            disabled={isLoading}
            className={`${provider?.bgColor} ${provider?.textColor} ${provider?.borderColor} hover:opacity-90`}
          >
            <div className="flex items-center justify-center space-x-2">
              <Icon name={provider?.icon} size={18} />
              <span className="hidden lg:inline">{provider?.name}</span>
            </div>
          </Button>
        ))}
      </div>
    </div>
  );
};

export default SocialLogin;